import { render, staticRenderFns } from "./discountCodeList.vue?vue&type=template&id=5926b2e2&"
import script from "./discountCodeList.vue?vue&type=script&lang=js&"
export * from "./discountCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports